import { EMPTY_STRING } from 'common/constants';
import { useState, useCallback } from 'react';
import React from 'react';
export type IValue = string;
export type TSetRadioState = (value: IValue) => void;
export type TChangeRadio = React.MouseEventHandler<HTMLButtonElement>;
export type TResult = [IValue, TChangeRadio, TSetRadioState];

type TUseRadioState = (initValue?: IValue) => TResult;

const useRadioState: TUseRadioState = (initValue) => {
  const [value, setValue] = useState<IValue>(() => initValue || EMPTY_STRING);

  const onChangeValue = useCallback(
    ({ target: { value = EMPTY_STRING } }: any) => {
      setValue((prevValue) => (prevValue === value ? EMPTY_STRING : value));
    },
    [setValue],
  );

  return [value, onChangeValue, setValue];
};

export default useRadioState;
